import React, { useState, useEffect } from 'react';
import App from './App';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';

const AutoRefreshApp = () => {
  const [key, setKey] = useState(0);

  const AutoRefresh = () => {
    const location = useLocation();

    useEffect(() => {
      if (location.pathname !== '/login') {
        const intervalId = setInterval(() => {
          setKey(prevKey => prevKey + 1);
        }, 60 * 1000); // 1 minute

        return () => clearInterval(intervalId);
      }
    }, [location.pathname]);

    return <App />;
  };

  return (
    <Router key={key}>
      <AutoRefresh />
    </Router>
  );
};

export default AutoRefreshApp;